import { render, staticRenderFns } from "./AICreditsBox.vue?vue&type=template&id=246f74b8&scoped=true&"
import script from "./AICreditsBox.vue?vue&type=script&lang=js&"
export * from "./AICreditsBox.vue?vue&type=script&lang=js&"
import style0 from "./AICreditsBox.vue?vue&type=style&index=0&id=246f74b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246f74b8",
  null
  
)

export default component.exports